import React from 'react'

import { Form, Formik } from 'formik';
import { toast } from 'react-toastify';

import Typography from '../../../components/Typography/Typography';
import { SendProfileValidation } from '../../../validations/SCValidation/TagValidation';
import { SCService } from '../../../services/SCService';
import { useLoader } from '../../../hooks';
import { Input } from '../../../components/Inputs/Input';

import myClasses from '../../../styles/Alerts.module.css';

const ConfirmSendProfileModal = ({ setOpen, id }) => {
  const [startLoader, stopLoader] = useLoader();

  const initialValues = { duration: 0 };

  const handleSendChargingProfile = (values) => {
    SCService.SendChargingProfile(
      id,
      { duration: values.duration },
      () => startLoader('sendProfile'),
      handleSendChargingProfileSuccess,
      handleError,
      () => stopLoader('sendProfile')
    );
  };

  const handleSendChargingProfileSuccess = () => {
    toast.success('Charging Profile Sent Successfully');
    setOpen();
  }

  const handleError = (err) => {
    setOpen();
    let data = err && err.response ? err.response.data : null;
    if (data) toast.error(data.message);
    else toast.error('Internal server error!');
  };

  return (
    <div className={myClasses.ModalWidth}>
      <Formik
        initialValues={initialValues}
        validationSchema={SendProfileValidation}
        onSubmit={(val, { resetForm }) => {
          handleSendChargingProfile(val, resetForm);
        }}
      >
        {({ errors, touched, values, isValidating, ...props }) => {
          return (
            <Form>
              <Typography content={"Send Charging Profile"} />
              <div>
                <div className={myClasses.InputContainer}>
                  <div className={myClasses.FieldControl2 + ' ' + myClasses.FieldControlGrow}>
                    <label for="duration">
                      Duration (seconds) <span className="required">*</span>
                    </label>
                    <Input type="number" name="duration" id="duration" />
                  </div>
                </div>
                <div className={myClasses.ButtonContainer}>
                  <div>
                    <div
                      className="btn-secondary"
                      onClick={() => {
                        setOpen(false);
                      }}
                    >
                      Cancel
                    </div>
                  </div>
                  <div>
                    <button type="submit" className="btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  )
}

export default ConfirmSendProfileModal